import React, {useState} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
//import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import ListIcon from '@mui/icons-material/List';
import {Inc,Owner,ZaikoSearchCondition} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import StoreImg from './StoreImg';
import ZaikoListSearch from './ZaikoListSearch';
import Title from './Title';
import AppBank from './AppBank';

interface ZaikoListProps {
	owner:Owner,
	bank:AppBank,
}
let page:number = 1;

const ZaikoList = (props:ZaikoListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        zaikos:[],
        isLoading:true,
        pager:null,
        cond:Inc.defaultZaikoSearchCondition(),
    });
    const search = (cond:ZaikoSearchCondition,first?:boolean)=>{
        //console.log("search",cond);
        setStates({...states,"isLoading":true});
        if( first ){
            page = 1;
        }
        window.scrollTo(0,0);
        Ajax.search("zaiko/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({zaikos:res.zaikos,cond:cond,pager:res.pager,isLoading:false});
            } else {
                setStates({...states,zaikos:[],pager:null,"isLoading":false});
            }
        });
    }
	const jump = (p:number)=>{
		//send(values,p);
		page = p;
		search(states.cond);
	}
	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
	return (
		<div id="zaiko_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="在庫確認" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
                        現在お預かりしている在庫（商品の個数）です。<br/>
                        「履歴」をクリックすると、これまでの在庫の変化が確認できます。<br/>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
									<Hidden smDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align='center'>画像</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>在庫</TableCell>
                                    <Hidden smDown implementation="js">
                                    <TableCell className={classes.tableHeadNowrap} align='center'>状態表示</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.zaikos.map( (zaiko:any,index:number)=>{
                            const key = "zaiko"+index;
                            const to = "/zaiko/"+String(zaiko.item_id);
                            return (
                                <TableRow key={key}>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellDense} align='center'><StoreImg owner_id={props.owner.owner_id} img_id={zaiko.img_id} className="imgList"/></TableCell>
                                    </Hidden>                                
                                    <TableCell className={classes.tableCellDense}>
                                        <span className={classes.itemId}>ID:{zaiko.item_id}</span>　
                                        <Hidden smUp implementation="js">
                                            <br/>
                                        </Hidden>
                                        {zaiko.item_name}<br/>
										{zaiko.page_name!==null && zaiko.page_name !== "" ? (
											<div className="with_page_name">{zaiko.page_name}</div>
										):(
											<div className="with_page_name">　</div>
										)}
                                    </TableCell>
                                    <TableCell className={classes.tableCellNowrap} align="right">{zaiko.num_stock}{zaiko.unit}</TableCell>
                                    <Hidden smDown implementation="js">
										{zaiko.admit_flag ? (
                                        <TableCell className={classes.tableCellNowrap} align="center" style={{width:'6em'}}>
                                            {Tools.colorLabel("item_status",zaiko.status,zaiko.status_label)}<br/>
                                        </TableCell>
										):(
                                        <TableCell className={classes.tableCellNowrap} align="center" style={{width:'6em'}}>
                                            {Tools.colorLabel("item_status",zaiko.status,'納品前')}<br/>
                                        </TableCell>
										)}
                                    </Hidden>                                
                                    <TableCell className={classes.tableCellNowrap} align="right" style={{width:'7em'}}>
                                        <Link to={to} className={classes.linkButton}><Button variant="outlined" color="primary"><ListIcon/>履歴</Button></Link>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                            </TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <ZaikoListSearch update={search} bank={props.bank} bankKey={"savedZaikoListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default ZaikoList;
